import {showNotification} from 'platform/components';
import {match} from 'ts-pattern';

import {isArray} from 'ramda-adjunct';

import {useDeleteSupplierOrderMutation} from '@dms/api/warehouse';
import {i18n} from '@dms/i18n';
import {warehouseRoutes} from '@dms/routes';
import {
  DmsDataGrid,
  WAREHOUSE_GRID_CODES,
  catchUnhandledDataGridActions,
  handleApiError,
} from '@dms/shared';
import {FullscreenDataGridWrapper} from '@dms/warehouse/shared-components';

import {composePath, useNavigate} from 'shared/web';

import type {ActionCallback} from 'features/eag-grid';

export function SupplierOrderList() {
  const navigate = useNavigate();

  const [deleteSupplierOrder] = useDeleteSupplierOrderMutation();

  const actionCallback: ActionCallback = async ({
    actionKey,
    rowId,
    sourceSearchParams,
    refreshData,
  }) => {
    const id = isArray(rowId) ? rowId[0] : rowId;

    await match(actionKey)
      .with('redirectDetail', 'edit', () => {
        navigate(
          composePath(warehouseRoutes.supplierOrderDetailOverview, {
            queryParams: sourceSearchParams,
            params: {id},
            isSearchParamsPreserved: false,
          })
        );
      })
      .with('delete', async () => {
        const orderId = isArray(rowId) ? rowId : [rowId];

        await deleteSupplierOrder({body: {orderId}})
          .unwrap()
          .then(() => showNotification.success(i18n.t('general.notifications.successfullyDeleted')))
          .then(() => refreshData())
          .catch(handleApiError);
      })
      .otherwise(() => catchUnhandledDataGridActions(actionKey));
  };

  return (
    <FullscreenDataGridWrapper hideCardWrapper>
      <DmsDataGrid
        gridCode={WAREHOUSE_GRID_CODES.warehouseSupplierOrders}
        actionCallback={actionCallback}
        data-testid={WAREHOUSE_GRID_CODES.warehouseSupplierOrders}
      />
    </FullscreenDataGridWrapper>
  );
}
